// Intersection Observer for Scrollspy functionality
document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.restaurant-category-container');
    const navLinks = document.querySelectorAll('.restaurant-category-link');
    const navContainer = document.querySelector('.restaurant-categories');

    if (sections.length === 0 || navLinks.length === 0) return;

    const observerOptions = {
        root: null,
        rootMargin: '-30% 0px -69% 0px', // Trigger when section is near top
        threshold: 0
    };

    const observerCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const id = entry.target.id;

                // Remove active class from all
                navLinks.forEach(link => link.classList.remove('active'));

                // Add active class to current
                const activeLink = document.querySelector(`.restaurant-category-link[href="#${id}"]`);
                if (activeLink) {
                    activeLink.classList.add('active');

                    // Scroll horizontal nav to keep active link in view
                    const linkLeft = activeLink.offsetLeft;
                    const linkWidth = activeLink.offsetWidth;
                    const containerWidth = navContainer.offsetWidth;

                    navContainer.scrollTo({
                        left: linkLeft - (containerWidth / 2) + (linkWidth / 2),
                        behavior: 'smooth'
                    });
                }
            }
        });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    sections.forEach(section => {
        observer.observe(section);
    });

    // Offset = pile collante réelle (announcement + header + nav sticky)
    function scrollOffset() {
        if (typeof stickyStackHeight === 'function') return stickyStackHeight() + 12;
        return 130; // repli
    }

    // Ancres natives (liens entrants #category-…) : scroll-margin dynamique
    function syncScrollMargins() {
        const margin = scrollOffset() + 'px';
        sections.forEach(section => { section.style.scrollMarginTop = margin; });
    }
    syncScrollMargins();
    window.addEventListener('resize', syncScrollMargins);

    // Smooth scroll for anchor clicks
    navLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            const targetId = this.getAttribute('href');
            const targetSection = document.querySelector(targetId);

            if (targetSection) {
                window.scrollTo({
                    top: targetSection.offsetTop - scrollOffset(),
                    behavior: 'smooth'
                });
            }
        });
    });
});

// ========== Recherche produit (filtrage côté client) ==========
window.filterMenu = function (query) {
    const q = (query || '').trim().toLowerCase();
    const cards = document.querySelectorAll('.restaurant-product-card');
    const containers = document.querySelectorAll('.restaurant-category-container');
    const nav = document.querySelector('.restaurant-categories');
    const clearBtn = document.getElementById('MenuSearchClear');
    const emptyMsg = document.getElementById('MenuSearchEmpty');

    if (clearBtn) clearBtn.hidden = q.length === 0;

    let anyVisible = false;

    cards.forEach(card => {
        const title = card.getAttribute('data-title') || '';
        const match = q === '' || title.indexOf(q) !== -1;
        card.style.display = match ? '' : 'none';
        if (match) anyVisible = true;
    });

    // Masque les catégories sans résultat pendant la recherche
    containers.forEach(container => {
        if (q === '') { container.style.display = ''; return; }
        const cardsIn = container.querySelectorAll('.restaurant-product-card');
        let hasMatch = false;
        cardsIn.forEach(c => { if (c.style.display !== 'none') hasMatch = true; });
        container.style.display = hasMatch ? '' : 'none';
    });

    // Masque la nav de catégories pendant une recherche active
    // (display:none — la nav est dans le flux, visibility laisserait un trou)
    if (nav) nav.style.display = q === '' ? '' : 'none';
    if (emptyMsg) emptyMsg.hidden = !(q !== '' && !anyVisible);
};

window.clearMenuSearch = function () {
    const input = document.getElementById('MenuSearchInput');
    if (input) input.value = '';
    window.filterMenu('');
    if (input) input.focus();
};
